import React, {useContext, useRef, useState} from 'react';
import callToast, {handleChangeData, postData, validateFormFields} from "../../../../utils/helper";
import {Button} from "primereact/button";
import {webInfo} from "../../../../utils/webInfo";
import {Toast} from "primereact/toast";
import {LayoutContext} from "../../../../layout/context/LayoutContext";
import {Password} from "primereact/password";

const UserSecurity = () => {
    const initialState = {
        current_password: '',
        new_password: '',
        new_password_confirmation: ''
    }
    const [formData, setFormData] = useState(initialState)
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [refresh, setRefresh] = useState<boolean>(false)
    const toastRef = useRef<Toast | null>(null);
    const {accessToken } = useContext(LayoutContext)


    const submitFormEndpointUrl = '/profile/password'


    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const validationRules = [
            { field: 'current_password', label: 'Current Password' },
            { field: 'new_password', label: 'New Password' },
            { field: 'new_password_confirmation', label: 'Confirm New Password' },
        ];

        if (!validateFormFields(formData, validationRules, toastRef)) return;

        if (formData.new_password !== formData.new_password_confirmation) {
            callToast(toastRef, false, 'New password and Confirm password  should be same.');
            return;
        }

        const payload =  {
            current_password: formData.current_password.replace(/\s+/g, ' ').trim(),
            new_password: formData.new_password.replace(/\s+/g, ' ').trim(),
            new_password_confirmation: formData.new_password_confirmation.replace(/\s+/g, ' ').trim(),
        };

        try {
            setIsSubmitting(true);
            const response = await fetch(`${webInfo?.baseUrl}${submitFormEndpointUrl}`, postData("PUT", accessToken, payload));

            if (response.ok) {
                callToast(toastRef, true, `Password updated successfully`);
                setFormData(initialState)
                setRefresh(!refresh);
                return;
            } else {
                const resData = await response.json();
                callToast(toastRef, false, resData.error);
            }

        } catch (err) {
            console.error('Failed to update', err);
        } finally {
            setIsSubmitting(false);
        }
    }


    return (
        <form onSubmit={handleSubmit}>
            <Toast ref={toastRef}/>

            <div className="grid">
                <div className="col-12 md:col-3">
                    <p className="mb-2 font-light text-sm text-600">Current Password</p>
                    <Password
                        value={formData.current_password}
                        placeholder="Enter current password"
                        inputClassName="w-full"
                        onChange={(e) => handleChangeData('current_password', e.target.value, formData, setFormData)}
                        feedback={false}
                        toggleMask
                    />
                </div>
            </div><div className="grid">
                <div className="col-12 md:col-3">
                    <p className="mb-2 font-light text-sm text-600">New Password</p>
                    <Password
                        value={formData.new_password}
                        placeholder="Enter new password"
                        inputClassName="w-full"
                        onChange={(e) => handleChangeData('new_password', e.target.value, formData, setFormData)}
                        toggleMask

                    />
                </div>
            </div><div className="grid">
                <div className="col-12 md:col-3">
                    <p className="mb-2 font-light text-sm text-600">Confirm new Password</p>
                    <Password
                        value={formData.new_password_confirmation}
                        placeholder="Confirm new password"
                        inputClassName="w-full"
                        onChange={(e) => handleChangeData('new_password_confirmation', e.target.value, formData, setFormData)}
                        toggleMask

                    />
                </div>
            </div>



            <div className="flex gap-2 mt-2">
                <Button
                    type="submit"
                    label={'Update' }
                    className="p-button-primary"
                    loading={isSubmitting}
                    size={'small'}
                    disabled={!formData.current_password || !formData.new_password || !formData.new_password_confirmation}
                    outlined

                />
            </div>
        </form>

    );
};

export default UserSecurity;